import React from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { PapiBadge, PapiUser } from '@wix/da-types-papi';
import Badges from './Badges';
import BadgeGifts from './Badges/BadgeGifts';
import givableBadgeItems from './Badges/BadgeGifts/givableBadgeItems';
import BadgeActivity from './BadgeActivity';
import { BadgeActivityItem } from '../../../../types/badge';
import s from './MyBadges.scss';

export interface Props {
  className?: string;
  badges: PapiBadge[];
  badgeActivity: BadgeActivityItem[];
  totalSent: number;
  totalReceived: number;
  isCurrentUserProfileOwner: boolean;
  profileOwnerUser: PapiUser;
}

export class MyBadges extends React.Component<Props & WithTranslation> {
  render() {
    const {
      badges,
      badgeActivity,
      totalSent,
      totalReceived,
      isCurrentUserProfileOwner,
      profileOwnerUser,
    } = this.props;
    const widthBreakpoints = [640, 800];
    return (
      <>
        <Badges
          className={s['section']}
          items={badges}
          widthBreakpoints={widthBreakpoints}
        />
        {true && (
          <BadgeGifts
            className={s['section']}
            items={givableBadgeItems}
            widthBreakpoints={widthBreakpoints}
          />
        )}
        <BadgeActivity
          className={s['activities']}
          totalSent={totalSent}
          totalReceived={totalReceived}
          items={badgeActivity}
          isOwner={isCurrentUserProfileOwner}
          ownerUsername={profileOwnerUser.username}
        />
      </>
    );
  }
}

export default withTranslation()(MyBadges);
